import FilterPortal from './FilterPortal'

export default FilterPortal
